import React from 'react';
import * as ReactDOM from 'react-dom';
import { Button, Modal, Toast, ListView, Icon } from 'antd-mobile';
import {post} from '../../utils/request';
import { getUrlParam, href } from '../../utils/util';
import api from './api';

import './index.less';
import Withdrawal from '../../withdrawal/index';

const NUM_SECTIONS = 10;
const NUM_ROWS_PER_SECTION = 10;
let pageIndex = 0;

let dataBlobs = {};
let sectionIDs = [];
let rowIDs = [];
function genData(pIndex = 0) {
    for (let i = 0; i < NUM_SECTIONS; i++) {
        const ii = (pIndex * NUM_SECTIONS) + i;
        const sectionName = `Section ${ii}`;
        sectionIDs.push(sectionName);
        dataBlobs[sectionName] = sectionName;
        rowIDs[ii] = [];

        for (let jj = 0; jj < NUM_ROWS_PER_SECTION; jj++) {
            const rowName = `S${ii}, R${jj}`;
            rowIDs[ii].push(rowName);
            dataBlobs[rowName] = rowName;
        }
    }
    sectionIDs = [...sectionIDs];
    rowIDs = [...rowIDs];
}

class WithdrawalRecordsList extends React.Component {
    constructor(...args) {
        super(...args);

        const getSectionData = (dataBlob, sectionID) => dataBlob[sectionID];
        const getRowData = (dataBlob, sectionID, rowID) => dataBlob[rowID];
        const dataSource = new ListView.DataSource({
            getRowData,
            getSectionHeaderData: getSectionData,
            rowHasChanged: (row1, row2) => row1 !== row2,
            sectionHeaderHasChanged: (s1, s2) => s1 !== s2,
        });

        this.state = {
            tabName: 1,
            dataSource,
            isLoading: true,
            hasMore: true,
            height: document.documentElement.clientHeight * 10 / 4,
            data: [],
            skipCount: 0,
            pageSize: 10,
        };
    }

    componentDidMount() {
    }

    componentWillMount() {
        this.init()
    }

    init(){
        sectionIDs = [];
        rowIDs = [];
        dataBlobs = {};
        pageIndex = 0;
        
        genData();
        this.getList();
    }

    getList(type){
        const {skipCount, pageSize} = this.state;
    
        post({
          url: api.selectCashOutRecordList + '?app_stoken=' + getUrlParam('app_stoken') + '&activity=365',
          data:{
            skipCount: skipCount * pageSize,
            pageSize: pageSize
          }
        }).then((res) => {
            // console.log('查询列表', res)
            // Toast.info(res.msg,1);
            if(res.result === 'success' && res.data || res.data.length > 0){
              this.setState({
                data: res.data
              },()=>{
                if(sectionIDs.length >= res.count){
                  this.setState({
                    hasMore: false
                  });
                }
                  const hei = res.data.length>0?document.documentElement.clientHeight - ReactDOM.findDOMNode(this.lv).parentNode.offsetTop:0;
                  this.setState({
                    dataSource: this.state.dataSource.cloneWithRowsAndSections(dataBlobs, sectionIDs, rowIDs),
                    isLoading: false,
                    height: hei,
                  });   
              });
            }else{
              
            }
        }, (res)=>{
            console.log('查询列表失败', res)
        });
    }
    
    
    onEndReached = (event) => {
        // load new data
        // hasMore: from backend data, indicates whether it is the last page, here is false
        if (this.state.isLoading || !this.state.hasMore) {
            return;
        }
        console.log('reach end', event);
        this.setState({ isLoading: true });
        setTimeout(() => {
            pageIndex++;
            genData(pageIndex);
            this.setState({
                skipCount: pageIndex
            },()=>{
                this.getList(1)
            });
        }, 1000);
    }

    viewPort =  () => {
        let u = navigator.userAgent.toLowerCase();
        return {
            isWeixin: u.indexOf('micromessenger') > -1,
            isQQ: u.indexOf('qq/') > -1,
            trident: u.indexOf('trident') > -1, //IE内核
            presto: u.indexOf('presto') > -1, //opera内核
            webKit: u.indexOf('applewebkit') > -1, //苹果、谷歌内核
            gecko: u.indexOf('gecko') > -1 && u.indexOf('khtml') == -1, //火狐内核
            mobile:
                !!u.match(/applewebkit.*mobile.*/) ||
                !!u.match(/applewebkit/), //是否为移动终端
            ios: !!u.match(/\(i[^;]+;( u;)? cpu.+mac os x/), //ios终端
            android: u.indexOf('android') > -1 || u.indexOf('linux') > -1, //android终端或者uc浏览器
            iPhone: u.indexOf('iphone') > -1 || u.indexOf('mac') > -1, //是否为iPhone或者QQHD浏览器
            iPad: u.indexOf('ipad') > -1, //是否iPad
            webApp: u.indexOf('safari') == -1 //是否web应该程序，没有头部与底部
        };
    }

    render() {
        const {data, urlOps} = this.state;
        // let index = data.length - 1;
        let index = 0;
        const row = (rowData, sectionID, rowID) => {
            let obj = {};
            if(index <= data.length - 1){
                obj = data[index++];
            }else{
                return (<div></div>)
            }
            
            return (
                <div className="item" key={rowID} onClick={()=>{
                    href(`/withdrawalRecords?cashOutType=${obj.cashOutType}&bankAccount=${obj.bankAccount}&gmtCreate=${obj.gmtCreate}&status=${obj.status}&cashNunmber=${obj.cashNunmber}&phoneNumber=${obj.phoneNumber}&cashOutAmount=${obj.cashOutAmount}&actualAmount=${obj.actualAmount}                                                        `)
                }}>
                    <div className="left">
                        <p style={{ fontSize: '0.14rem', color: '#333333' }}>
                            {obj.status=='0'?'申请已经提交':(obj.status=='1'?'已到账':'提现失败')}
                        </p>
                        <p style={{ fontSize: '0.12rem', color: '#666666', lineHeight: '0.01rem' }}>
                            {obj.gmtCreate}
                        </p>
                    </div>
                    <div className='right'>
                        <span style={{ position: 'absolute', right: '0.4rem', fontSize: '0.19rem', color: '#009F90', fontWeight: '600' }}>{obj.cashOutType=='2'?obj.actualAmount:obj.cashOutAmount}元</span><Icon type='right' style={{ position: 'absolute', top: '0.23rem', right: '0.1rem', width: '0.18rem', height: '0.2rem' }} />
                    </div>
                </div>
            );
        };
        
        return (
            <div>
                {this.state.data.length>0?<ListView
                    className="am-list"
                    ref={el => this.lv = el}
                    dataSource={this.state.dataSource}
                    renderFooter={() => (data.length<10?'':<div style={{ padding: 24, textAlign: 'center' }}>
                        {this.state.isLoading ? '加载中...' : '已经到底了！'}
                    </div>)}
                    renderRow={row}
                    style={{
                        height: this.state.height,
                        overflow: 'auto',
                    }}
                    pageSize={10}
                    onScroll={() => { console.log('scroll'); }}
                    scrollRenderAheadDistance={500}
                    onEndReached={this.onEndReached}
                    onEndReachedThreshold={10}
                />:<div className="noData">
                    <div>暂无提现记录</div>
                </div>}
                </div>
        );
    }
}
export default WithdrawalRecordsList;


// WEBPACK FOOTER //
// ./src/withdrawalRecordsList/index/index.js